<template>

  <div class="search-sort-by">

    <div class="row">

      <div class="col-12 d-none d-lg-block mb-3">

        <ul class="list-inline vehicle_sort float-right mb-0 mr-1">

          <li id="vehicle_sort_by" class="list-inline-item"><h6>Sort By:</h6></li>

          <li class="end list-inline-item" v-if="typeof (searchFilters.sortBy) !== 'undefined'">
            <a
              href="#"
              class="btn btn-outline-secondary btn-sm small"
              rel="nofollow"
              role="button"
              @click.prevent="clearSortBy"
            >
              [x] clear
            </a>
          </li>

          <li class="end list-inline-item">
            <a
              href="#"
              class="btn btn-outline-primary btn-sm small"
              rel="nofollow"
              role="button"
              @click.prevent="sortClicked('year')"
            >
              <svg
                v-if="searchFilters.sortBy === 'year'"
                class="icon"
                :class="getSortIcon()">
                  <use :xlink:href="'/assets/svg/symbol-defs.svg#' + getSortIcon()"></use>
              </svg>
              &nbsp;Year
            </a>
          </li>

          <li class="end list-inline-item">
            <a
              href="#"
              class="btn btn-outline-primary btn-sm small"
              rel="nofollow"
              role="button"
              @click.prevent="sortClicked('make')"
            >
              <svg
                v-if="searchFilters.sortBy === 'make'"
                class="icon"
                :class="getSortIcon()">
                  <use :xlink:href="'/assets/svg/symbol-defs.svg#' + getSortIcon()"></use>
              </svg>
              &nbsp;Make
            </a>
          </li>

          <li class="end list-inline-item">
            <a
              href="#"
              class="btn btn-outline-primary btn-sm small"
              rel="nofollow"
              role="button"
              @click.prevent="sortClicked('model')"
            >
              <svg
                v-if="searchFilters.sortBy === 'model'"
                class="icon"
                :class="getSortIcon()">
                  <use :xlink:href="'/assets/svg/symbol-defs.svg#' + getSortIcon()"></use>
              </svg>
              &nbsp;Model
            </a>
          </li>

          <li class="end list-inline-item">
            <a
              href="#"
              class="btn btn-outline-primary btn-sm small"
              rel="nofollow"
              role="button"
              @click.prevent="sortClicked('final_price')"
            >
              <svg
                v-if="searchFilters.sortBy === 'final_price'"
                class="icon"
                :class="getSortIcon()">
                  <use :xlink:href="'/assets/svg/symbol-defs.svg#' + getSortIcon()"></use>
              </svg>
              &nbsp;Price
            </a>
          </li>

          <li class="end list-inline-item">
            <a
              href="#"
              class="btn btn-outline-primary btn-sm small"
              rel="nofollow"
              role="button"
              @click.prevent="sortClicked('mileage')"
            >
              <svg
                v-if="searchFilters.sortBy === 'mileage'"
                class="icon"
                :class="getSortIcon()">
                  <use :xlink:href="'/assets/svg/symbol-defs.svg#' + getSortIcon()"></use>
              </svg>
              &nbsp;Odometer
            </a>
          </li>

          <li class="end list-inline-item">
            <a
              href="#"
              class="btn btn-outline-primary btn-sm small"
              rel="nofollow"
              role="button"
              @click.prevent="sortClicked('fuel_economy_city_high')"
            >
              <svg
                v-if="searchFilters.sortBy === 'fuel_economy_city_high'"
                class="icon"
                :class="getSortIcon()">
                  <use :xlink:href="'/assets/svg/symbol-defs.svg#' + getSortIcon()"></use>
              </svg>
              &nbsp;MPG
            </a>
          </li>

        </ul>

      </div>

    </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SearchSortBy',
  computed: {
    ...mapState(['searchFilters'])
  },
  data () {
    return {
    }
  },
  methods: {
    calcSortType: function (sortBy, sortType) {
      // is sortBy defined?
      if (typeof (this.searchFilters.sortBy) === 'undefined') {
        return 'asc'
      }
      // did sortBy change?
      if (this.searchFilters.sortBy === sortBy) {
        // same sortBy: alternate desc, asc
        if (this.searchFilters.sortType === 'asc') {
          return 'desc'
        } else {
          return 'asc'
        }
      } else {
        // sortBy has changed but keep our current sortType
        return this.searchFilters.sortType
      }
    },
    getSortIcon: function () {
      if (this.searchFilters.sortType === 'asc') {
        return 'icon-arrow-up'
      } else {
        return 'icon-arrow-down'
      }
    },
    clearSortBy: function () {
      this.searchFilters.sortType = undefined
      this.searchFilters.sortBy = undefined
      this.searchFilters.page = undefined

      // push to router
      this.$root.pushToRouter(name, this.searchFilters)
    },
    /**
     * This is the actual functionality when sort links are clicked
     */
    sortClicked: function (sortBy) {
      this.searchFilters.sortType = this.calcSortType(sortBy)

      // get route name (new or used)
      const name = this.$route.name

      // assign our new page # to searchFilters
      this.searchFilters.sortBy = sortBy

      // push to router
      this.$root.pushToRouter(name, this.searchFilters)
    }
  }
}
</script>

<style>

</style>
